/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { KomboCreateConnectLinkPathParams, KomboCreateConnectLinkResponse } from '../types/KomboCreateConnectLink'

/**
 * POST /export-integrations/kombo/:organisation/create-connect-link
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/KomboController.php KomboController::createConnectLink
 */
export async function komboCreateConnectLink(
	organisation: KomboCreateConnectLinkPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<KomboCreateConnectLinkResponse>> {
	return axiosInstance.post(`/export-integrations/kombo/${organisation}/create-connect-link`, undefined, config)
}
